import { useEffect, useState, useCallback } from 'react';
import { THEMES, applyTheme, getInitialTheme } from './index.js';

/**
 * useTheme  -  hook that mounts with the resolved initial theme, applies
 * its CSS variables to <html>, and exposes a setter that persists the
 * choice via localStorage. URL is deliberately not touched: deep-links
 * shouldn't carry UI preferences.
 */
export function useTheme() {
  const [theme, setThemeState] = useState(() => getInitialTheme());

  useEffect(() => {
    applyTheme(theme);
  }, [theme]);

  const setTheme = useCallback((id) => {
    if (THEMES[id]) setThemeState(id);
  }, []);

  return { theme, setTheme };
}
